














































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import Button from "@/shared/components/ui/Button.vue";
import ExpenseCategoryWidgetRow from "@/employee/components/widgets/ExpenseCategoryWidgetRow.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { RawLocation } from "vue-router";
import * as RouteNames from "@/employee/route-names";
import { useContributionStore } from "@/shared/store/contribution";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useExpenseByCategoryStore } from "@/employee/store/expenseByCategory";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    Button,
    ExpenseCategoryWidgetRow,
    GenericLoadingSpinner
  }
})
export default class ExpenseCategoryWidget extends Vue {
  contributionStore = useContributionStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  expenseByCategory = useExpenseByCategoryStore();
  featureFlagStore = useFeatureFlagStore();
  custodianSettingStore = useCustodianSettingsStore();

  formatCurrency = formatCurrency;

  mounted () {
    // the expenseByCategory store will not work without this being called
    this.contributionStore.getPlanDetails();
    this.expenseBalanceSummaryStore.loadState();
    this.expenseByCategory.changeSelectedYear(this.expenseByCategory.selectedYear);
  }

  get hasExpenses (): boolean {
    return !!this.expenseByCategory.selectedYearTotal && this.expenseByCategory.isLoaded;
  }

  get location (): RawLocation {
    return this.useNewLink ? { name: RouteNames.FindExpenses }
      : { name: RouteNames.HealthcareExpenses };
  }

  get locationText (): string {
    return this.useNewLink ? "Find more eligible expenses" : "Review Expenses";
  }

  get useNewLink (): boolean {
    return this.custodianSettingStore.displayNewHealthcareExpenses;
  }

  get hasUnreviewedExpenses () {
    return this.expenseBalanceSummaryStore.likelyEligibleBalance > 0;
  }
}
